import styled from 'styled-components'

export const RangeContainer = styled.div`
  padding: 20px 23px;
`

export const InputContainer = styled.div<{autoSubmit?: boolean }>`
  display: flex;
  padding: 0 10px;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: start;

  label {
    display: none !important;
  }

  > * {
    width: ${props => props.autoSubmit ? 'calc(50% - 10px)' : 'calc(50% - 40px)'};
  }

  > button {
    width: 70px;
    display: block;
    cursor: pointer;
    outline: 0;
    padding: 10px;
    color: ${props => props.theme.palette.general.strong};
    border: 1px solid ${props => props.theme.palette.general.greyLight};
    background: ${props => props.theme.palette.general.soft};
  }
`
